export class NetworkError extends Error {}
